import React from 'react';
import PropTypes from 'prop-types';
import {Button, makeStyles, Paper} from '@material-ui/core';
import Modal from '../common/Modal';
import {useListFacilities} from 'hooks/lists';
import ClassroomAdminReadingNightsTable from './ClassroomAdminReadingNightsTable';
import ClassroomAdminReadingNightsForm from './ClassroomAdminReadingNightsForm';
import {fetchClassroomStudentReadingNights} from 'api/classrooms';

const useStyles = makeStyles({
  information: {
    padding: 20,
  },
});

const ClassroomAdminReadingNightsList = ({classroomId}) => {
  const classes = useStyles();
  const {
    tableState,
    refreshTable,
    selectPage,
    selectItemsPerPage,
    changeFilter,
    changeSorter,
    changeExtraFilters,
    modalOpen,
    currentRecord,
    openModal,
    closeModal,
    triggerSoftRefresh,
  } = useListFacilities({
    fetchRecords: (...args) => fetchClassroomStudentReadingNights(classroomId, ...args),
  });

  return (
    <React.Fragment>
      <Modal
        title={currentRecord ? 'Update Reading Nights' : 'Create Reading Nights'}
        onClose={closeModal}
        open={modalOpen}
        maxWidth="sm"
        renderContent={() => (
          <ClassroomAdminReadingNightsForm
            initialValues={currentRecord}
            onCancel={closeModal}
            onSubmitSuccess={triggerSoftRefresh}
            classroomId={classroomId}
          />
        )}
      />
      <div className="container content-box">
        <Paper className={classes.information}>
          <h3 className="section-header">
            <div className="section-title">Student Reading Nights</div>
          </h3>
          <ClassroomAdminReadingNightsTable
            {...{
              tableState,
              refreshTable,
              selectPage,
              selectItemsPerPage,
              changeFilter,
              changeSorter,
              changeExtraFilters,
              showUpdateModal: openModal,
            }}
          />
        </Paper>
      </div>
    </React.Fragment>
  );
};

ClassroomAdminReadingNightsList.propTypes = {
  classroomId: PropTypes.string.isRequired,
};

export default ClassroomAdminReadingNightsList;
